import type { ModuleTag } from '../schemas';
import styles from './Tag.module.css';

interface TagProps {
  readonly children: ModuleTag;
}

export function Tag({ children }: TagProps) {
  return <span className={styles.tag}>{children}</span>;
}
